import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_ranked_badges';
const STRATEGIES = {PDP: 'PDP', PDP_PRICING: 'PDP_PRICING'};

// Example set of params for the query
/*
{
    "listingId": "321.887611.1435551"
}
 */

let rankedBadgesQuery = `
    query rankedBadges($listingId : String!,  $startDate : String, $endDate : String) {
        rankedBadges(listingTriad : $listingId, startDate : $startDate, endDate : $endDate, rankingStrategy: PDP) {
            id
            name
            helpText,
        }
    }
`;

function rankedBadgesGraphQl({listingId, startDate, endDate, locale, strategy}) {
    if (Object.values(STRATEGIES).includes(strategy)) {
        rankedBadgesQuery = rankedBadgesQuery.replace('PDP', strategy);
    }

    return graphqlQuery(
        OPERATION_NAME,
        rankedBadgesQuery,
        {listingId, startDate, endDate},
        locale
    ).catch(() => null);
}

export default rankedBadgesGraphQl;
export {OPERATION_NAME, STRATEGIES, rankedBadgesGraphQl, rankedBadgesQuery};
